/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Percent_TitleInputs */

const en_us2_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight by percentage of max strength`)
};

const pt_br2_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso por porcentagem da força máxima`)
};

const es_419_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso por porcentaje de la fuerza máxima`)
};

const pt_pt2_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso por percentagem da força máxima`)
};

const fr_fr2_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge en pourcentage de la force max`)
};

const de_de2_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht nach Prozent der Maximalkraft`)
};

const it_it2_exercise_sheet_percent_title = /** @type {(inputs: Exercise_Sheet_Percent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso per percentuale della forza massima`)
};

/**
* | output |
* | --- |
* | "Weight by percentage of max strength" |
*
* @param {Exercise_Sheet_Percent_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_percent_title = /** @type {((inputs?: Exercise_Sheet_Percent_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Percent_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_percent_title(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_percent_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_percent_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_percent_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_percent_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_percent_title(inputs)
	return en_us2_exercise_sheet_percent_title(inputs)
});
export { exercise_sheet_percent_title as "exercise-sheet.percent_title" }